import React from 'react';
export function EasyToUseSection() {
  return <div className="w-full max-w-[1400px] mt-16 px-4" data-id="element-216">
      <div className="bg-gray-200 rounded-3xl overflow-hidden shadow-lg" data-id="element-217">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center" data-id="element-218">
          {/* Text Content */}
          <div className="p-8 md:p-12" data-id="element-219">
            <h3 className="text-3xl md:text-5xl font-bold text-black mb-6 leading-tight" data-id="element-220">
              Easy to Use, No Skills Needed
            </h3>
            <p className="text-lg md:text-xl text-black leading-relaxed" data-id="element-221">
              Simply place the fruit, press the button, and watch the peel
              spiral off neatly. No learning curve, no fuss—just effortless
              peeling that anyone in the family can handle, from kids helping
              out to grandparents enjoying fresh fruit.
            </p>
          </div>

          {/* Image */}
          <div className="relative" data-id="element-222">
            <img src="https://cdn.magicpatterns.com/uploads/q6CP2hyThsQsPosksaUqso/image.png" alt="Easy to use peeling machine with grapes" className="w-full h-auto rounded-2xl" data-id="element-223" />
          </div>
        </div>
      </div>
    </div>;
}